import React, { useRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createChatSession } from "./redux/AISagas";
import MessageComposer from "./smartComponents/MessageComposer";
import Message from "./smartComponents/Message";
import AIHeader from "./smartComponents/AIHeader";
import Sidebar from "./smartComponents/Sidebar";
import AILoader from "./smartComponents/AILoader";
import AIError from "./smartComponents/AIError";
import { useScrollToLastMessage } from "./hooks/useScrollToLastMessage";
import usePdf from "./hooks/usePdf";

import "./ai-page.scss";

const AIPage = () => {
  const dispatch = useDispatch();
  const [inputMessage, setInputMessage] = useState("");
  const errors = useSelector((state) => state.ai.errors);

  const initialRequest = useSelector((state) => state.ai.initialRequest);
  const loading = useSelector((state) => state.ai.isLoading);
  const messages = useSelector((state) => state.ai.currentSession.messages);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    dispatch(createChatSession());
  }, []);

  useScrollToLastMessage(messagesEndRef, [messages.length, errors]);
  const pdf = usePdf(messagesEndRef);
  const hasContent = !(loading && initialRequest);

  return (
    <div className="ai-agent" id="ai-page" data-testid="ai-page">
      <Sidebar />

      <div className="ai">
        <AIHeader exportDetails={hasContent && pdf} errors={errors} />
        <div className="ai__content" ref={messagesEndRef}>
          {loading && initialRequest ? (
            <AILoader size="large" />
          ) : (
            messages.map((messageItem, idx) => (
              <Message
                key={idx}
                messageItem={messageItem}
                setInputMessage={setInputMessage}
                isFirstMessage={idx === 0}
              />
            ))
          )}
          <AIError />

          {loading && !initialRequest && <AILoader size="small" />}
        </div>

        {!initialRequest && (
          <MessageComposer inputMessage={inputMessage} setInputMessage={setInputMessage} />
        )}
      </div>
    </div>
  );
};

export default AIPage;
